const Scroll = {
  /**
   * Animate a property of an element.
   * @param property
   * @param element
   * @param duration
   * @param targetValue
   * @private
   */
  _animateProperty({property, element, duration, targetValue}) {
    if (!element || !(property in element) || !duration) {
      return;
    }

    const tickDelta = Math.floor(((targetValue - element[property]) / duration) * 100);
    if (!tickDelta) {
      return;
    }

    setTimeout(() => {
      element[property] += tickDelta;
      if (
        (tickDelta < 0 && element[tickDelta] <= targetValue) ||
        (tickDelta > 0 && element[tickDelta] >= targetValue)
      ) {
        return;
      }
      this._animateProperty({property, element, duration, targetValue});
    }, 10);
  },

  /**
   * Scroll element to the given position.
   * @param element
   * @param duration
   * @param position
   */
  scrollTo(element, duration, position) {
    this._animateProperty({
      property: 'scrollTop',
      element,
      duration,
      targetValue: position,
    });
  },

  /**
   * Scroll to top of the page.
   */
  toPageTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  },

  /**
   * Scroll to top of given element.
   * @param element
   * @param duration
   * @param offset
   */
  toElementTop(element, duration = 1000, offset = 0) {
    this.scrollTo(element, duration, offset);
  },
};

export {Scroll};
